var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalApplications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H9V9H1.5L1.5 1.5ZM0 1.5C0 0.671573 0.671573 0 1.5 0H9C9.82843 0 10.5 0.671573 10.5 1.5V9C10.5 9.82843 9.82843 10.5 9 10.5H1.5C0.671573 10.5 0 9.82843 0 9V1.5ZM1.5 15H9V22.5H1.5L1.5 15ZM0 15C0 14.1716 0.671573 13.5 1.5 13.5H9C9.82843 13.5 10.5 14.1716 10.5 15V22.5C10.5 23.3284 9.82843 24 9 24H1.5C0.671573 24 0 23.3284 0 22.5V15ZM22.5 1.5H15V9H22.5V1.5ZM15 0C14.1716 0 13.5 0.671573 13.5 1.5V9C13.5 9.82843 14.1716 10.5 15 10.5H22.5C23.3284 10.5 24 9.82843 24 9V1.5C24 0.671573 23.3284 0 22.5 0H15ZM13.9393 22.5003C13.6464 22.7932 13.6464 23.2681 13.9393 23.561C14.2322 23.8539 14.7071 23.8539 15 23.561L22.5003 16.061V20.25C22.5003 20.6642 22.8361 21 23.2503 21C23.6645 21 24.0003 20.6642 24.0003 20.25V14.25C24.0003 13.8358 23.6645 13.5 23.2503 13.5H17.2503C16.8361 13.5 16.5003 13.8358 16.5003 14.25C16.5003 14.6642 16.8361 15 17.2503 15H21.4399L13.9393 22.5003Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalApplications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-applications.cee85590d0e38260639985e4dbae14e5.svg";